import { Cancel, Closet } from "iconoir-react";
import React, { useState } from "react";
import Swal from "sweetalert2";
import Swalgeneral from "../../../Landing/General/Swalgeneral";
import { domain } from "../../../Urls/Services/Api_urls";
import { handleKeyPress } from "../../Apoyo/handleKeyPress";

export const Poligonadd = (props) => {
  const token = window.sessionStorage.getItem("token");
  const url = domain + "/polygons/";
  const [cdo, setcdo] = useState("");
  const [social_stratum, setsocial_stratum] = useState("");
  const [city, setcity] = useState("");
  // const [locality_type, setlocality_type] = useState("");
  const [arregloCoordenadas, setpolygon] = useState([]);
  let objeto,
    objeto1 = [];
  /**
   * The function `Poligonaddfun` is a JavaScript function that prompts the user with a confirmation
   * message and then sends a POST request to a specified URL with the provided credentials.
   * @param e - The parameter `e` is an event object that is passed to the function when an event is
   * triggered. It is commonly used to prevent the default behavior of an event, such as form
   * submission.
   */
  const Poligonaddfun = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Seguro que quieres agregar el polígono",
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "No",
      allowOutsideClick: false,
      confirmButtonColor: "#3085d6",
      showConfirmButton: true,
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.isConfirmed) {
        const polygon = JSON.parse(arregloCoordenadas); //validar
        const credentials = { cdo, polygon, social_stratum, city };

        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(credentials),
        }).then(async function (response) {
          const respuesta = await response.json();
          if (response.status === 200) {
            Swal.fire({
              title: "Polígono guardado",
              html: "Polígono guardado de manera satisfactoria",
              icon: "success",
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonColor: "#3085d6",
              showConfirmButton: true,
              confirmButtonText: "ok",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          } else {
            objeto = respuesta;
            console.log(objeto);
            objeto1 = Promise.resolve(JSON.stringify(objeto));
            Swalgeneral("Error", "error", "text", objeto1);
            
          }
        });
      }
    });
  };

  return (
    <div className="row">
      <button
      className="btn72"
          style={{
            position: "relative",
            margin: "1rem",
            left: "30%",
            padding: "1rem",
          }}
          value={"none"}
          onClick={props.HandleChangeDisplay}
        >
          <Cancel />
          Cerrar
        </button>
      <h3 style={{ padding: "1rem" }}>Añadir poligonos</h3>
      <form onSubmit={Poligonaddfun}>
        <input
          className="col-md-12"
          type="text"
          placeholder="CDO"
          id="cdo"
          required
          value={cdo}
          onChange={(e) => setcdo(e.target.value)}
          style={{ marginBottom: "1rem", height: "6rem", width: "80%" }}
        />
        <input
          className="col-md-12"
          type="text"
          required
          placeholder="ESTRATO"
          id="social_stratum"
          value={social_stratum}
          onChange={(e) => setsocial_stratum(e.target.value)}
          style={{ marginBottom: "1rem", height: "6rem", width: "80%" }}
        />
        <select
          class="select"
          className="swal2-input"
          value={city}
          required
          onChange={(e) => setcity(e.target.value)}
          style={{ marginBottom: "1rem", width: "80%", height: "6rem" }}
        >
          <option value="">Ciudad</option>
          <option value="76001">Cali</option>
          <option value="76364">Jamundi</option>
          <option value="76892">Yumbo</option>
          <option value="76130">Candelaria</option>
          <option value="Puerto 19573">Puerto tejada</option>
          <option value="76520">Palmira</option>
        </select>
        {/* <select
          class="select"
          className="swal2-input"
          value={locality_type}
          required
          onChange={(e) => setlocality_type(e.target.value)}
          style={{ marginBottom: "1rem", width: "80%", height: "6rem" }}
        >
          <option value="">Tipo de zona</option>
          <option value="1">Rural</option>
          <option value="2">Urbano</option>
       
        </select> */}
        <textarea
          onKeyPress={handleKeyPress}
          className="col-md-12"
          type="text"
          required
          placeholder="[
            [-76.558024857999953, 3.36232314800003],
            [-76.558211888999949, 3.3622669800000722] ...]"
          id="polygon"
          value={arregloCoordenadas}
          rows="10"
          cols="30"
          onChange={(e) => setpolygon(e.target.value)}
          style={{ marginBottom: "1rem", height: "18rem", width: "80%" }}
        />
        <div style={{ height: 0 }} />
        <button
          className="bu1"
          variant="contained"
          type="submit"
        >
          Añadir
        </button>
      </form>
      <div style={{ height: 20 }} />
    </div>
  );
};


// ## Summary
// This code defines a React component called `Poligonadd` that allows users to add polygons. It includes a form with input fields for the polygon coordinates, city, CDO, and social stratum. When the form is submitted, a confirmation message is displayed using the `Swal.fire` function from the SweetAlert2 library. If the user confirms, a POST request is sent to a specified URL with the form data. If the request is successful, a success message is displayed, and if there is an error, an error message is displayed using the `Swalgeneral` function.

// ## Example Usage
// ```javascript
// import { Poligonadd } from "./Poligonadd";

// const App = () => {
//   return (
//     <div>
//       <Poligonadd />
//     </div>
//   );
// };

// ReactDOM.render(<App />, document.getElementById("root"));
// ```

// ## Code Analysis
// ### Inputs
// - `props` (object): The props passed to the `Poligonadd` component.
// ___
// ### Flow
// 1. The `Poligonadd` component renders a form with input fields for the polygon coordinates, city, CDO, and social stratum.
// 2. When the form is submitted, the `Poligonaddfun` function is called.
// 3. The `Poligonaddfun` function displays a confirmation message using the `Swal.fire` function.
// 4. If the user confirms, a POST request is sent to the specified URL with the form data.
// 5. If the request is successful (status code 200), a success message is displayed using the `Swal.fire` function.
// 6. If there is an error, the response is parsed and an error message is displayed using the `Swalgeneral` function.
// ___
// ### Outputs
// - None. The `Poligonadd` component renders a form and displays messages using the SweetAlert2 library.
// ___
